"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleTrimListForYear_Make_Model = exports.vehicleTrimRead = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const VehicleTrim_1 = require("../models/VehicleTrim");
const PATH = 'vehicle-trims';
async function vehicleTrimRead(id, firestore) {
    const result = await firestore.read(PATH, id);
    return (0, VehicleTrim_1.vehicleTrimDeserialize)(result.value, result.id);
}
exports.vehicleTrimRead = vehicleTrimRead;
async function vehicleTrimListForYear_Make_Model(year, make, model, firestore) {
    const results = await firestore.list(PATH, {
        where: [
            ['year', '==', year],
            ['make', '==', make],
            ['model', '==', model],
        ],
    });
    const trims = results.map(result => (0, VehicleTrim_1.vehicleTrimDeserialize)(result.value, result.id));
    return (0, sortBy_1.default)(trims, vehicle => vehicle.name);
}
exports.vehicleTrimListForYear_Make_Model = vehicleTrimListForYear_Make_Model;
